<template>
  <div class="content-box">
    <Title />
    <div>
      <!-- <div class="title-right">
        <a href="https://www.100ec.cn/zt/25315wh/" target="_blank">
          <img src="https://www.100ec.cn/zt/25315wh/img/960.gif" />
        </a>
      </div> -->
    </div>
    <el-menu
      :default-active="activeIndex"
      class="el-menu-demo"
      mode="horizontal"
    >
      <el-menu-item
        :index="String(index + 1)"
        v-for="(i, index) of dataNav"
        :key="index"
        @click="handleSelect(index)"
      >
        {{ i.label }}</el-menu-item
      >
    </el-menu>

    <div class="mobile-select">
      <el-select v-model="name" @change="handleSelect2">
        <el-option
          v-for="item in dataNav"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>

    <Textlist />
  </div>
</template>

<script>
export default {
  name: "broadCast",
  data() {
    return {
      activeIndex: "1",
      name: "滚动播报",
      dataNav: [
        {
          value: "私域",
          label: "滚动播报",
        },
        {
          value: "天猫 私域",
          label: "天猫",
        },
        {
          value: "淘宝 私域",
          label: "淘宝",
        },
        {
          value: "视频号 私域",
          label: "视频号",
        },
        {
          value: "有赞 私域",
          label: "有赞",
        },
        {
          value: "小红书 私域",
          label: "小红书",
        },
        {
          value: "唯品会 私域",
          label: "唯品会",
        },
        {
          value: "东方甄选 私域",
          label: "东方甄选",
        },
        {
          value: "支付宝 私域",
          label: "支付宝",
        },
        {
          value: "鲸灵集团 私域",
          label: "鲸灵集团",
        },
        {
          value: "蜂享家 私域",
          label: "蜂享家",
        },
        {
          value: "聚宝赞 私域",
          label: "聚宝赞",
        },
        {
          value: "白皮书 私域",
          label: "白皮书",
        },
        {
          value: "私域流量",
          label: "私域流量",
        },
        {
          value: "团长",
          label: "团长",
        },
        {
          value: "达人",
          label: "达人",
        },
        {
          value: "特卖",
          label: "特卖",
        },
        {
          value: "团购",
          label: "团购",
        },
        {
          value: "会员",
          label: "会员",
        },
      ],
      params: {
        json: 0,
        filter: [
          "分析",
          "（PPT）",
          "（全文）",
          "实战：",
          "张周平",
          "曹磊",
          "莫岱青",
          "蒙慧欣",
          "李鹏博",
          "朱秋城",
          "林智勇",
          "吕友臣",
          "刘俊斌",
        ],
      },
    };
  },
  created() {
    this.$store.commit("textparams", this.params);
    this.$store.commit("changeKeys", this.dataNav[0].value);
    this.$store.dispatch("getText");
  },
  methods: {
    handleSelect(index) {
      this.$store.commit("changeKeys", this.dataNav[index].value);
      this.$store.dispatch("getText");
    },
    handleSelect2(value) {
      this.$store.commit("changeKeys", value);
      this.$store.dispatch("getText");
    },
  },
};
</script>
<style scoped>
#app .content-left .el-menu--horizontal > .el-menu-item {
  height: auto;
  line-height: 40px;
  padding: 0 16px;
}
.title {
  position: relative;
}
.title-right {
  position: absolute;
  left: 195px;
  top: 65px;
}
.title-right img {
  width: 580px;
  height: 70px;
}
@media (max-width: 1100px) {
  .title-right {
    position: static;
    margin: 10px 0;
  }
  .title-right img {
    width: 100%;
    height: 50px;
  }
}
</style>